import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";

function AdminLogin() {
  const navigate = useNavigate();
  const [step, setStep] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mfaCode, setMfaCode] = useState("");
  const [trustBrowser, setTrustBrowser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleLoginSubmit(event) {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await fetch("/api/admin/auth/login", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });
      const data = await response.json();
      if (!response.ok || !(data.ok || data.mfa_required)) throw new Error(data.error || "Unable to sign in.");
      if (data.authenticated) navigate("/admin", { replace: true });
      else if (data.mfa_required) setStep("mfa");
      else throw new Error("Additional verification was not started.");
    } catch (requestError) {
      setError(requestError.message === "Failed to fetch" ? "Admin service unavailable. Check the local backend." : requestError.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleMfaSubmit(event) {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await fetch("/api/admin/auth/mfa", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: mfaCode, trust_browser: trustBrowser })
      });
      const data = await response.json();
      if (!response.ok || !data.authenticated) throw new Error(data.error || "Verification failed.");
      navigate("/admin", { replace: true });
    } catch (requestError) {
      setError(requestError.message === "Failed to fetch" ? "Admin service unavailable. Check the local backend." : requestError.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="bubly-admin-login">
      <section className="bubly-admin-login-card">
        <div className="bubly-admin-login-brand">
          <img
            src="/assets/img/bublyuplogoheader-admin.png"
            alt="BublyUp Admin"
          />
        </div>

        {step === "login" ? (
          <>
            <div className="bubly-admin-login-heading">
              <span>ADMINISTRATION</span>
              <h1>Sign in to BublyUp Admin</h1>
              <p>Authorized personnel only.</p>
            </div>

            <form
              className="bubly-admin-login-form"
              onSubmit={handleLoginSubmit}
            >
              <label htmlFor="admin-email">Email</label>
              <input
                id="admin-email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="username"
                required
              />

              <label htmlFor="admin-password">Password</label>
              <input
                id="admin-password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="current-password"
                required
              />

              <button type="submit" disabled={loading}>{loading ? "Verifying…" : "Sign in"}</button>
            </form>
          </>
        ) : (
          <>
            <div className="bubly-admin-login-heading">
              <span>SECURITY VERIFICATION</span>
              <h1>Verification required</h1>
              <p>Enter the code from your authenticator app.</p>
            </div>

            <form
              className="bubly-admin-login-form"
              onSubmit={handleMfaSubmit}
            >
              <label htmlFor="admin-mfa-code">Authenticator code</label>
              <input
                id="admin-mfa-code"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={6}
                value={mfaCode}
                onChange={(event) => setMfaCode(event.target.value)}
                autoComplete="one-time-code"
                required
              />

              <label className="bubly-admin-login-trust">
                <input
                  type="checkbox"
                  checked={trustBrowser}
                  onChange={(event) => setTrustBrowser(event.target.checked)}
                />
                <span>Trust this browser for 7 days</span>
              </label>

              <button type="submit" disabled={loading}>{loading ? "Verifying…" : "Verify"}</button>
            </form>
          </>
        )}
        {error && <p className="bubly-admin-login-error" role="alert">{error}</p>}
      </section>
    </main>
  );
}

export default AdminLogin;
